import React, { useEffect, useState } from 'react';
import '../../../style/myContent.css';
import CreateFlashcardSetModel from '../components/CreateFlashcardSetModal';
import CustomToast from '../../../../../components/Toast';
import { useGetQuestionSetsMutation, useGetCanShowDeletedMutation, useCreateResourceSetMutation } from '../../../../../features/authentication/qSetApiSlice';
import { languages } from '../../../utils/contants';
import { useGetShowDeletedTeacherSetsMutation, useUpdateShowDeletedTeacherSetsMutation } from '../../../../../features/authentication/persistApiSlice';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import SetListing from '../../../components/SetListing';
import EmptySet from '../../../components/EmptySet';
import ActivityTypes from '../../../../../enums/activityTypes';
import { useNavigate } from 'react-router';

const FlashcardSets = () => {
  const [updateShowDeletedSetsPersist] = useUpdateShowDeletedTeacherSetsMutation();
  const [isOpenCreateFlashcardSet, setIsOpenCreateFlashcardSet] = useState(false);
  const [flashcardSets, setFlashcardSets] = useState(null);
  const [skip, setSkip] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const takeSize = 9;
  const [showDeletedSets, setShowDeletedSets] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [showDisplayDeletedSetCheckbox, setShowDisplayDeletedSetCheckbox] = useState(false);
  const navigate = useNavigate();

  const [getFlashcardSets, { isLoading }] = useGetQuestionSetsMutation();
  const [getShowDeletedSetsPersist] = useGetShowDeletedTeacherSetsMutation();
  const [getCanShowDeleted] = useGetCanShowDeletedMutation();
  const [createFlashcardSet] = useCreateResourceSetMutation();
  
  useEffect(() => {
    getShowDisplayDeletedSetCheckboxAsync();
    getShowDeletedPersistAsync();
  }, []);

  useEffect(() => {
    if(showDeletedSets != null)
      getFlashcardSetsAsync(skip, takeSize, searchText, showDeletedSets);
  }, [showDeletedSets]);

  const getShowDeletedPersistAsync = async () => {
    let response = await getShowDeletedSetsPersist().unwrap();
    setShowDeletedSets(response);
    return response;
  };
  
  const getFlashcardSetsAsync = async(skip, take, searchText, showDeletedSets) => {
    try{
      const options = {
        skip: skip,
        take: take,
        searchString: searchText,
        activityTypes : [ActivityTypes.FlashCard],
        showDeleted : showDeletedSets
      };
      
      let response = await getFlashcardSets(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
      else {
        let updatedQuestionSets = response.data.data.map(item => ({
          ...item,
          languageId: languages[0]?.id
        }));

        setFlashcardSets(updatedQuestionSets);
        setPageCount(Math.ceil(response.data.total/takeSize));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowDeletedChangesAsync = async() => {
    setShowDeletedSets(!showDeletedSets);
    let options = {
      showDeleted : !showDeletedSets
    };
    await updateShowDeletedSetsPersist(options);
  };
  
  const handleCreateSet = () => {
    setIsOpenCreateFlashcardSet(true);
  };

  const getShowDisplayDeletedSetCheckboxAsync = async() => {
    let response = await getCanShowDeleted().unwrap();
    setShowDisplayDeletedSetCheckbox(response.canShowDeleted);
  };

  const createFlashcardSetAsync = async (setName)=>{
    const option = {
      description: setName,
      activityType: ActivityTypes.FlashCard
    };

    try {
      const result = await createFlashcardSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Flash Card Set Created', 'success');
        setIsOpenCreateFlashcardSet(false);
        navigate(`${result.data}/flashcards`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {(searchText == '' && isLoading) || flashcardSets == null ?
        <SkeletonGrid
          rowCount={3}
          colCount={3} 
          className={'h-150 mb-3'}
        />
        : searchText.length > 0 || flashcardSets?.length > 0 ?
          <SetListing
            setSetsList={setFlashcardSets}
            setsList={flashcardSets}
            setOpenCreateSet={setIsOpenCreateFlashcardSet}
            setSearchText={setSearchText}
            searchText={searchText}
            pageCount={pageCount}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            getSets={getFlashcardSetsAsync}
            setSkip={setSkip}
            takeSize={takeSize}
            showDeletedSets ={showDeletedSets}
            handleShowDeletedChanges={handleShowDeletedChangesAsync}
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            showDisplayDeletedSetCheckbox={showDisplayDeletedSetCheckbox}
          />
          :
          <EmptySet
            handleCreateSet={handleCreateSet}
            showDeletedSets={showDeletedSets}
            handleShowDeletedChanges={handleShowDeletedChangesAsync}
            showDisplayDeletedSetCheckbox={showDisplayDeletedSetCheckbox}
          />
      }

      <CreateFlashcardSetModel
        isOpen={isOpenCreateFlashcardSet}
        onClose={() => setIsOpenCreateFlashcardSet(false)}
        onSave={createFlashcardSetAsync}
        showFlashcardOptions={true}
      />
    </>
  );
};
  
export default FlashcardSets;